export default __webpack_public_path__ + "static/media/Panel_1_Stage1.5814c20c.svg";